import React, { createContext, useContext, useState } from "react";
import { useMediaQuery, useTheme } from "@mui/material";

// The Phone Shell's one full-screen view (cas-mobile-shell D5; Terms: Phone View).
export type PhoneView = "page" | "browse" | "chats" | "cas";

const PhoneViewContext = createContext<{ view: PhoneView; setView: (v: PhoneView) => void } | undefined>(undefined);

export const PhoneViewProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [view, setView] = useState<PhoneView>(() => (/^\/(newchat|chat\/)/.test(window.location.pathname) ? "cas" : "page"));
  return <PhoneViewContext.Provider value={{ view, setView }}>{children}</PhoneViewContext.Provider>;
};

export function usePhoneView() {
  const ctx = useContext(PhoneViewContext);
  if (!ctx) throw new Error("usePhoneView must be used within PhoneViewProvider");
  return ctx;
}

// Below `sm` (600 px), the breakpoint the AI panel and the side nav already treat as a phone.
export function useIsPhone(): boolean {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.down("sm"));
}
